import React from 'react';
import { getOrderingAvailability } from '../services/dashboardService';
import { OrderingAvailability } from '../types/app';

const OPEN: OrderingAvailability = {
  acceptingOrders: true,
  paused: false,
  outsideHours: false,
  message: null,
  reason: 'open',
};

const POLL_MS = 60_000;

export function useOrderingAvailability() {
  const [status, setStatus] = React.useState<OrderingAvailability>(OPEN);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let cancelled = false;

    const load = () =>
      getOrderingAvailability()
        .then((next) => {
          if (!cancelled) setStatus(next);
        })
        .catch(() => {
          if (!cancelled) setStatus(OPEN);
        })
        .finally(() => {
          if (!cancelled) setLoading(false);
        });

    void load();
    const id = window.setInterval(() => {
      void load();
    }, POLL_MS);

    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, []);

  return { ...status, loading };
}

/** @deprecated Prefer useOrderingAvailability — kept for gradual migration. */
export function useOrdersPauseStatus() {
  const { paused, message, loading, acceptingOrders, outsideHours, reason } = useOrderingAvailability();
  return { paused: !acceptingOrders && paused, message, loading, acceptingOrders, outsideHours, reason };
}
